import React, { useState } from 'react'
import { downloadNotes } from '../../controllers/classnotes.controller';
import {toast} from "react-hot-toast";

function classNote({name, user, date,download}) {


  function downloadArchive() {
    downloadNotes(download).then(
      (data) => {
        let link= document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('target','_blank');
        link.setAttribute('download', data);
        link.click();
        toast.success("Documento abierto")
      }
    ).catch( error => toast.error(error))
  }

  return (
    
      <div className='rounded-4 bg-white p-3 d-flex flex-row flex-wrap' onClick={downloadArchive}>
        <span className='col-8'><p className='fw-bold'>{name}</p></span>
        <span className='col-3 text-end'><p>{date}</p></span>
        <div className='col-12 col-md-2 text-center'><p>{user}</p></div>
      </div>
    
  )
}

export default classNote